import { render, staticRenderFns } from "./SGPInfoCardComponent.vue?vue&type=template&id=3a2b228c&scoped=true"
import script from "./SGPInfoCardComponent.vue?vue&type=script&lang=js"
export * from "./SGPInfoCardComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPInfoCardComponent.vue?vue&type=style&index=0&id=3a2b228c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b228c",
  null
  
)

export default component.exports